import { ImagesMobile } from '@/assets/images';
import { isMobile } from '@/utils/mobile.util';
import { DownOutlined } from '@ant-design/icons';
import { memo } from 'react';

import {
	Collapse as AntdCollapse,
	CollapseProps as AntdCollapseProps,
} from 'antd';
import { cn } from 'utils/common.util';

type CollapseProps = AntdCollapseProps & {};

const Collapse = ({
	rootClassName,
	ghost = true,
	collapsible = 'header',
	expandIconPosition = 'end',
	...props
}: CollapseProps) => {
	return (
		<AntdCollapse
			rootClassName={cn(
				'bg-white sm:rounded-2xl xl:px-10 xl:py-7 sm:px-[70px] sm:py-6 px-0 py-6  relative',
				rootClassName,
				isMobile
					? 'assignment-calendar-mobile [&>.assignment-calendar-item>.assignment-calendar-header]:md:!text-[18px] !rounded-none static'
					: ''
			)}
			{...{ ghost, collapsible, expandIconPosition }}
			{...props}
			expandIcon={({ isActive }) => (
				<div
					className={cn(
						'transition-all cursor-pointer',
						isActive ? '-rotate-0' : 'rotate-180'
					)}
				>
					{!isMobile ? (
						<DownOutlined />
					) : (
						<img
							src={ImagesMobile.iconAccordion}
							className="w-[24px] h-[24px] md:w-[28px] md:h-[28px]"
						/>
					)}
				</div>
			)}
		/>
	);
};

export default memo(Collapse);
